import React from 'react'

const PathogenOverall = () => {
  return (
    <div id='website-responsive'  style={{ overflow:'hidden'}} >
        <div className='py-md-5 py-4 left-padding10rem1 right-padding10rem1' style={{ padding:'', }} >
        <div className='pb-md-0 pb-4 left-padding8rem right-padding8rem' style={{ padding:'', }} >
            <center>
                <div className='bg-ss-secondary rounded10 py-md-4 py-3' style={{ boxShadow:'5px 3px 12px 0 rgba(0,0,0,.5)' }}>
                    <div className='fs-ss-18 text-white text-montserrat fw-600 pb-1'>
                        Overall, 97.1% sensitivity and 99.3% specificity (prospective specimens)
                    </div>
                    <div className='fs-ss-18 text-white text-montserrat  fw-600'>
                        SARS-CoV-2 98.0% sensitivity and 100% specificity (archived specimens)
                    </div>
                    <div className='fs-ss-18 text-white text-montserrat  fw-600'>
                        SARS-CoV-2 100% PPA and 100% NPA (contrived specimens)
                    </div>
                </div>
            </center>
        </div>
        </div>
    </div>
  )
}

export default PathogenOverall